import React from 'react';
import Button from '../../../../common/_custom/Button/Button';
import { copyIcon } from '../../../../assets/hostedassets';
import TickIcon from '../../../../assets/Svg/TickIcon';
import styles from './GstOverview.module.scss';
import { COPIED_LABEL, GST_CONSENT_LINK_LABEL } from './constants';

interface GstConsentLinkButtonProps {
    copied: boolean;
    loading: boolean;
    onClick: () => void;
}

/** Copies the borrower's GST consent magic link; the label confirms with "Copied" without changing the button's width. */
function GstConsentLinkButton({ copied, loading, onClick }: Readonly<GstConsentLinkButtonProps>) {
    return (
        <Button
            type="button"
            className={styles.GstConsentLogLink}
            icon={
                copied ? (
                    <TickIcon width={14} height={14} color="var(--risk-indicator-green)" aria-hidden="true" />
                ) : (
                    <img src={copyIcon} alt="" aria-hidden="true" width="14" height="14" />
                )
            }
            text={
                <span className={styles.IdleSizedLabel} data-idle-label={GST_CONSENT_LINK_LABEL}>
                    {copied ? COPIED_LABEL : GST_CONSENT_LINK_LABEL}
                </span>
            }
            disabled={loading}
            aria-busy={loading}
            onClick={onClick}
        />
    );
}

export default GstConsentLinkButton;
